function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGardeningImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.9,185.09s-24.33-45.71-78-52.48-91.24,26.24-130.77,43.17c-20.71,8.86-44.35,5.42-66.33,9.71C67.47,199.21,41,285.18,70.27,334.07c25.34,42.32,69.94,64.33,137.86,69.41s115.57,11,176.39-30.48S441.29,245.19,412.9,185.09Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.9,185.09s-24.33-45.71-78-52.48-91.24,26.24-130.77,43.17c-20.71,8.86-44.35,5.42-66.33,9.71C67.47,199.21,41,285.18,70.27,334.07c25.34,42.32,69.94,64.33,137.86,69.41s115.57,11,176.39-30.48S441.29,245.19,412.9,185.09Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.37,141.66c-2.62-1.43-3.8-.24-4.75-1.43s2.61-4.27-4.51-7.36c0,0-.48-6.65-10.21-6.88s-7.12,6.64-9.73,8.31-3.33-1-5.94.71-1.42,5-3.56,5.46-5-2.14-7.6-.48-2.61,3.09-3.8,3.09-3.56-1-5,0-3.09,2.14-3.09,2.14h60.07S194,143.08,191.37,141.66Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.37,141.66c-2.62-1.43-3.8-.24-4.75-1.43s2.61-4.27-4.51-7.36c0,0-.48-6.65-10.21-6.88s-7.12,6.64-9.73,8.31-3.33-1-5.94.71-1.42,5-3.56,5.46-5-2.14-7.6-.48-2.61,3.09-3.8,3.09-3.56-1-5,0-3.09,2.14-3.09,2.14h60.07S194,143.08,191.37,141.66Z",
    style: {
      fill: "#008C8E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.37,141.66c-2.62-1.43-3.8-.24-4.75-1.43s2.61-4.27-4.51-7.36c0,0-.48-6.65-10.21-6.88s-7.12,6.64-9.73,8.31-3.33-1-5.94.71-1.42,5-3.56,5.46-5-2.14-7.6-.48-2.61,3.09-3.8,3.09-3.56-1-5,0-3.09,2.14-3.09,2.14h60.07S194,143.08,191.37,141.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.37,141.66c-2.62-1.43-3.8-.24-4.75-1.43s2.61-4.27-4.51-7.36c0,0-.48-6.65-10.21-6.88s-7.12,6.64-9.73,8.31-3.33-1-5.94.71-1.42,5-3.56,5.46-5-2.14-7.6-.48-2.61,3.09-3.8,3.09-3.56-1-5,0-3.09,2.14-3.09,2.14h60.07S194,143.08,191.37,141.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.43,118.57c-4.88-2.66-7.09-.44-8.86-2.66s4.87-8-8.42-13.73c0,0-.89-12.41-19.06-12.85s-13.29,12.4-18.16,15.5-6.21-1.77-11.08,1.33-2.66,9.31-6.65,10.19-9.3-4-14.18-.88-4.87,5.76-7.08,5.76-6.65-1.77-9.31,0-5.76,4-5.76,4H388S389.3,121.23,384.43,118.57Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.43,118.57c-4.88-2.66-7.09-.44-8.86-2.66s4.87-8-8.42-13.73c0,0-.89-12.41-19.06-12.85s-13.29,12.4-18.16,15.5-6.21-1.77-11.08,1.33-2.66,9.31-6.65,10.19-9.3-4-14.18-.88-4.87,5.76-7.08,5.76-6.65-1.77-9.31,0-5.76,4-5.76,4H388S389.3,121.23,384.43,118.57Z",
    style: {
      fill: "#008C8E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.43,118.57c-4.88-2.66-7.09-.44-8.86-2.66s4.87-8-8.42-13.73c0,0-.89-12.41-19.06-12.85s-13.29,12.4-18.16,15.5-6.21-1.77-11.08,1.33-2.66,9.31-6.65,10.19-9.3-4-14.18-.88-4.87,5.76-7.08,5.76-6.65-1.77-9.31,0-5.76,4-5.76,4H388S389.3,121.23,384.43,118.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.43,118.57c-4.88-2.66-7.09-.44-8.86-2.66s4.87-8-8.42-13.73c0,0-.89-12.41-19.06-12.85s-13.29,12.4-18.16,15.5-6.21-1.77-11.08,1.33-2.66,9.31-6.65,10.19-9.3-4-14.18-.88-4.87,5.76-7.08,5.76-6.65-1.77-9.31,0-5.76,4-5.76,4H388S389.3,121.23,384.43,118.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.52,220.88c-.4,1.49.85,3.54.27,4.94s-2.92,2-3.69,3.31-.09,3.62-1,4.84-3.33,1.15-4.42,2.24-1,3.48-2.24,4.41-3.51.26-4.84,1-1.88,3.09-3.3,3.68-3.45-.66-4.94-.26-2.62,2.49-4.16,2.7-3.15-1.54-4.7-1.54-3.21,1.73-4.71,1.54-2.68-2.31-4.15-2.7-3.53.85-4.94.26-2-2.92-3.3-3.68-3.63-.09-4.84-1-1.16-3.33-2.24-4.41-3.48-1-4.42-2.24-.26-3.51-1-4.84-3.09-1.88-3.68-3.31.66-3.45.26-4.94-2.49-2.61-2.69-4.15,1.54-3.15,1.54-4.71-1.74-3.2-1.54-4.7,2.3-2.68,2.69-4.15-.85-3.54-.26-4.94,2.92-2,3.68-3.31.1-3.63,1-4.84,3.33-1.15,4.41-2.24,1-3.48,2.24-4.41,3.51-.26,4.84-1,1.88-3.09,3.31-3.68,3.45.66,4.94.26,2.62-2.5,4.15-2.7,3.15,1.54,4.71,1.54,3.2-1.73,4.7-1.54,2.69,2.31,4.15,2.7,3.54-.85,4.94-.27,2,2.92,3.31,3.69,3.63.09,4.84,1,1.16,3.33,2.24,4.41,3.48,1,4.41,2.24.26,3.51,1,4.84,3.1,1.88,3.69,3.3-.67,3.46-.27,4.95,2.5,2.61,2.7,4.15-1.54,3.15-1.54,4.7,1.73,3.21,1.54,4.71S373.91,219.41,373.52,220.88Zm-198.2-16c-.33-1.21.69-2.87.21-4s-2.37-1.62-3-2.69-.08-2.95-.83-3.93-2.71-.94-3.59-1.82-.83-2.83-1.82-3.59-2.85-.2-3.93-.83-1.53-2.51-2.69-3-2.8.54-4,.21-2.12-2-3.37-2.19-2.56,1.25-3.82,1.25-2.61-1.41-3.83-1.25-2.17,1.88-3.37,2.19-2.87-.69-4-.21-1.61,2.37-2.69,3-2.94.08-3.93.84-.94,2.7-1.82,3.58-2.82.83-3.58,1.82-.21,2.85-.84,3.93-2.51,1.53-3,2.69.54,2.8.22,4-2,2.12-2.19,3.37,1.25,2.56,1.25,3.82-1.41,2.61-1.25,3.83,1.87,2.18,2.19,3.37-.69,2.87-.22,4,2.37,1.62,3,2.69.07,3,.83,3.93,2.71.94,3.59,1.82.83,2.83,1.81,3.58,2.86.21,3.94.84,1.53,2.51,2.68,3,2.8-.54,4-.21,2.13,2,3.38,2.19,2.56-1.25,3.82-1.25,2.6,1.4,3.82,1.25,2.18-1.88,3.37-2.2,2.87.69,4,.22,1.61-2.37,2.68-3,2.95-.08,3.93-.84.94-2.7,1.82-3.58,2.83-.83,3.59-1.82.21-2.85.83-3.93,2.52-1.53,3-2.69-.54-2.8-.21-4,2-2.13,2.19-3.37-1.25-2.56-1.25-3.83,1.41-2.6,1.25-3.82S175.64,206,175.32,204.83Zm128.2-18.62c.39-1.46,2.5-2.61,2.7-4.15s-1.54-3.15-1.54-4.7,1.73-3.21,1.54-4.71-2.31-2.68-2.7-4.15.85-3.54.27-4.94-2.92-2-3.69-3.31-.09-3.63-1-4.84-3.33-1.15-4.41-2.24-1-3.48-2.24-4.41-3.51-.26-4.84-1-1.88-3.09-3.31-3.68-3.45.66-4.94.26-2.61-2.49-4.15-2.69-3.15,1.54-4.7,1.54-3.21-1.74-4.71-1.54-2.68,2.3-4.15,2.69-3.54-.84-4.94-.26-2,2.92-3.31,3.68-3.63.1-4.84,1-1.15,3.33-2.24,4.42-3.48,1-4.41,2.24-.26,3.51-1,4.84-3.09,1.88-3.68,3.3.66,3.45.26,4.94-2.49,2.62-2.69,4.15,1.54,3.15,1.54,4.71-1.74,3.2-1.54,4.7,2.3,2.69,2.69,4.15a4,4,0,0,1,0,1.71c-1.2-.2-2.67,0-3.63-.57-1.32-.76-1.88-3.09-3.31-3.68s-3.45.67-4.94.27-2.61-2.5-4.15-2.7-3.15,1.54-4.7,1.54-3.21-1.74-4.71-1.54-2.68,2.3-4.15,2.7-3.54-.85-4.94-.27-2,2.92-3.31,3.69-3.63.09-4.84,1-1.16,3.34-2.24,4.42-3.48,1-4.41,2.24-.26,3.51-1,4.84-3.09,1.88-3.68,3.3.66,3.45.26,4.95-2.49,2.61-2.69,4.15,1.54,3.15,1.54,4.7-1.74,3.21-1.54,4.71,2.3,2.68,2.69,4.15-.85,3.53-.26,4.94,2.92,2,3.68,3.31.1,3.62,1,4.84,3.33,1.15,4.41,2.24,1,3.48,2.24,4.41,3.52.26,4.85,1,1.88,3.09,3.3,3.68,3.45-.66,4.94-.27,2.62,2.5,4.15,2.7,3.15-1.54,4.71-1.54,3.2,1.74,4.7,1.54,2.69-2.3,4.15-2.7,3.54.85,4.95.27,2-2.92,3.3-3.69,3.63-.09,4.84-1,1.16-3.33,2.24-4.42,3.48-1,4.42-2.24.25-3.51,1-4.84,3.1-1.88,3.69-3.3-.67-3.45-.27-4.94,2.5-2.62,2.7-4.15-1.54-3.16-1.54-4.71,1.73-3.2,1.54-4.71-2.31-2.68-2.7-4.15a3.93,3.93,0,0,1,0-1.7c1.2.2,2.66,0,3.63.56,1.32.77,1.88,3.1,3.3,3.69s3.45-.67,4.94-.27,2.62,2.5,4.15,2.7,3.15-1.54,4.71-1.54,3.2,1.73,4.7,1.54,2.69-2.31,4.16-2.7,3.53.85,4.94.27,2-2.92,3.3-3.69,3.63-.09,4.84-1,1.16-3.33,2.24-4.41,3.48-1,4.42-2.24.25-3.51,1-4.84,3.1-1.88,3.69-3.31S303.12,187.7,303.52,186.21Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.52,220.88c-.4,1.49.85,3.54.27,4.94s-2.92,2-3.69,3.31-.09,3.62-1,4.84-3.33,1.15-4.42,2.24-1,3.48-2.24,4.41-3.51.26-4.84,1-1.88,3.09-3.3,3.68-3.45-.66-4.94-.26-2.62,2.49-4.16,2.7-3.15-1.54-4.7-1.54-3.21,1.73-4.71,1.54-2.68-2.31-4.15-2.7-3.53.85-4.94.26-2-2.92-3.3-3.68-3.63-.09-4.84-1-1.16-3.33-2.24-4.41-3.48-1-4.42-2.24-.26-3.51-1-4.84-3.09-1.88-3.68-3.31.66-3.45.26-4.94-2.49-2.61-2.69-4.15,1.54-3.15,1.54-4.71-1.74-3.2-1.54-4.7,2.3-2.68,2.69-4.15-.85-3.54-.26-4.94,2.92-2,3.68-3.31.1-3.63,1-4.84,3.33-1.15,4.41-2.24,1-3.48,2.24-4.41,3.51-.26,4.84-1,1.88-3.09,3.31-3.68,3.45.66,4.94.26,2.62-2.5,4.15-2.7,3.15,1.54,4.71,1.54,3.2-1.73,4.7-1.54,2.69,2.31,4.15,2.7,3.54-.85,4.94-.27,2,2.92,3.31,3.69,3.63.09,4.84,1,1.16,3.33,2.24,4.41,3.48,1,4.41,2.24.26,3.51,1,4.84,3.1,1.88,3.69,3.3-.67,3.46-.27,4.95,2.5,2.61,2.7,4.15-1.54,3.15-1.54,4.7,1.73,3.21,1.54,4.71S373.91,219.41,373.52,220.88Zm-198.2-16c-.33-1.21.69-2.87.21-4s-2.37-1.62-3-2.69-.08-2.95-.83-3.93-2.71-.94-3.59-1.82-.83-2.83-1.82-3.59-2.85-.2-3.93-.83-1.53-2.51-2.69-3-2.8.54-4,.21-2.12-2-3.37-2.19-2.56,1.25-3.82,1.25-2.61-1.41-3.83-1.25-2.17,1.88-3.37,2.19-2.87-.69-4-.21-1.61,2.37-2.69,3-2.94.08-3.93.84-.94,2.7-1.82,3.58-2.82.83-3.58,1.82-.21,2.85-.84,3.93-2.51,1.53-3,2.69.54,2.8.22,4-2,2.12-2.19,3.37,1.25,2.56,1.25,3.82-1.41,2.61-1.25,3.83,1.87,2.18,2.19,3.37-.69,2.87-.22,4,2.37,1.62,3,2.69.07,3,.83,3.93,2.71.94,3.59,1.82.83,2.83,1.81,3.58,2.86.21,3.94.84,1.53,2.51,2.68,3,2.8-.54,4-.21,2.13,2,3.38,2.19,2.56-1.25,3.82-1.25,2.6,1.4,3.82,1.25,2.18-1.88,3.37-2.2,2.87.69,4,.22,1.61-2.37,2.68-3,2.95-.08,3.93-.84.94-2.7,1.82-3.58,2.83-.83,3.59-1.82.21-2.85.83-3.93,2.52-1.53,3-2.69-.54-2.8-.21-4,2-2.13,2.19-3.37-1.25-2.56-1.25-3.83,1.41-2.6,1.25-3.82S175.64,206,175.32,204.83Zm128.2-18.62c.39-1.46,2.5-2.61,2.7-4.15s-1.54-3.15-1.54-4.7,1.73-3.21,1.54-4.71-2.31-2.68-2.7-4.15.85-3.54.27-4.94-2.92-2-3.69-3.31-.09-3.63-1-4.84-3.33-1.15-4.41-2.24-1-3.48-2.24-4.41-3.51-.26-4.84-1-1.88-3.09-3.31-3.68-3.45.66-4.94.26-2.61-2.49-4.15-2.69-3.15,1.54-4.7,1.54-3.21-1.74-4.71-1.54-2.68,2.3-4.15,2.69-3.54-.84-4.94-.26-2,2.92-3.31,3.68-3.63.1-4.84,1-1.15,3.33-2.24,4.42-3.48,1-4.41,2.24-.26,3.51-1,4.84-3.09,1.88-3.68,3.3.66,3.45.26,4.94-2.49,2.62-2.69,4.15,1.54,3.15,1.54,4.71-1.74,3.2-1.54,4.7,2.3,2.69,2.69,4.15a4,4,0,0,1,0,1.71c-1.2-.2-2.67,0-3.63-.57-1.32-.76-1.88-3.09-3.31-3.68s-3.45.67-4.94.27-2.61-2.5-4.15-2.7-3.15,1.54-4.7,1.54-3.21-1.74-4.71-1.54-2.68,2.3-4.15,2.7-3.54-.85-4.94-.27-2,2.92-3.31,3.69-3.63.09-4.84,1-1.16,3.34-2.24,4.42-3.48,1-4.41,2.24-.26,3.51-1,4.84-3.09,1.88-3.68,3.3.66,3.45.26,4.95-2.49,2.61-2.69,4.15,1.54,3.15,1.54,4.7-1.74,3.21-1.54,4.71,2.3,2.68,2.69,4.15-.85,3.53-.26,4.94,2.92,2,3.68,3.31.1,3.62,1,4.84,3.33,1.15,4.41,2.24,1,3.48,2.24,4.41,3.52.26,4.85,1,1.88,3.09,3.3,3.68,3.45-.66,4.94-.27,2.62,2.5,4.15,2.7,3.15-1.54,4.71-1.54,3.2,1.74,4.7,1.54,2.69-2.3,4.15-2.7,3.54.85,4.95.27,2-2.92,3.3-3.69,3.63-.09,4.84-1,1.16-3.33,2.24-4.42,3.48-1,4.42-2.24.25-3.51,1-4.84,3.1-1.88,3.69-3.3-.67-3.45-.27-4.94,2.5-2.62,2.7-4.15-1.54-3.16-1.54-4.71,1.73-3.2,1.54-4.71-2.31-2.68-2.7-4.15a3.93,3.93,0,0,1,0-1.7c1.2.2,2.66,0,3.63.56,1.32.77,1.88,3.1,3.3,3.69s3.45-.67,4.94-.27,2.62,2.5,4.15,2.7,3.15-1.54,4.71-1.54,3.2,1.73,4.7,1.54,2.69-2.31,4.16-2.7,3.53.85,4.94.27,2-2.92,3.3-3.69,3.63-.09,4.84-1,1.16-3.33,2.24-4.41,3.48-1,4.42-2.24.25-3.51,1-4.84,3.1-1.88,3.69-3.31S303.12,187.7,303.52,186.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.07,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,207.76l-8.23-10a1.94,1.94,0,0,0-3,0L120,207.76V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,207.76l-8.23-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,207.76l-8.23-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.09,207.76l-8.23-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.09,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.09,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.77,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.1,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.11,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.77,9.92V361.32h19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.07,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,207.76l-8.23-10a1.94,1.94,0,0,0-3,0L120,207.76V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,207.76l-8.23-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,207.76l-8.23-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.09,207.76l-8.23-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.09,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.09,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.77,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.1,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,207.76l-8.22-10a1.94,1.94,0,0,0-3,0l-7.76,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.11,207.76l-8.23-10a1.93,1.93,0,0,0-3,0l-7.77,9.92V361.32h19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,365.42l22.62.47-7.88-2.35-1.56-.36-2.55-.58,1.71-6.11-2.74,2.82v-5.17L428.19,356l-3.08-5.64-1.37,3.76-2.4-7.52L420,354.14l-3.77-4.23v7.52l-5.15-3.76-.34,3.76-3.43-6.58-1,6.11-3.08-4.23.34,5.17-1.72-1.11.93-2.18L400.54,356l-2.17-1.39.93,2.18-1.72,1.11.34-5.17L394.83,357l-1-6.11-3.42,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52L376,350.38,372.89,356l-4.11-1.88v5.17L366,356.49l1.71,6.11-2.56.58-1.55.36-1.58.47H358.7l2.06-4.23-4.46.47,2.4-5.64-5.14,3.29.34-5.17L350.82,357l-1-6.11-3.43,6.58-.34-3.76-5.14,3.76v-7.52l-3.77,4.23-1.38-7.52-2.4,7.52L332,350.38,328.88,356l-4.12-1.88v5.17L322,356.49l1.72,6.11-2.56.58-1.56.36-.12,0,2.22-3.79-5.35.47,2.88-5.64-6.18,3.29.41-5.17-3.7,4.23-1.24-6.11-4.12,6.58-.41-3.76-6.18,3.76v-7.52l-4.53,4.23-1.65-7.52-2.88,7.52-1.65-3.76L283.41,356l-1.94-.74.17-2.55-1.49,2-1.68-.64v2.29l-.94-5.58-3.43,6.58-.34-3.76-5.15,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L256.62,356l-4.12-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64-5.14,3.29.34-5.17L242.42,357l-1-6.11L238,357.43l-.34-3.76-5.15,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L220.49,356l-4.12-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64L209,357.9l.34-5.17L206.29,357l-1-6.11-3.42,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L184.35,356l-4.11-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64-5.15,3.29.35-5.17L170.16,357l-1-6.11-3.42,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L148.22,356l-4.11-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64-5.15,3.29.35-5.17L134,357l-1-6.11-3.43,6.58-.34-3.76-5.14,3.76v-7.52l-3.77,4.23L119,346.62l-2.4,7.52-1.37-3.76L112.09,356l-2.87-1.32,0-.09-.11.06-1.17-.53v1.29l-2.33,1.48-.41-.42.16.59-1.28.82.34-5.17L101.37,357l-1-6.11-3.43,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L79.44,356l-4.12-1.88v5.17l-2.74-2.82,1.71,6.11-2.55.58-1.56.36-7.88,2.35,22.62-.47-6.51,4.23,34.22-1-1.57,1,37.87-1.13-1.74,1.13,37.87-1.13-1.73,1.13,37.86-1.13-1.73,1.13,37.87-1.13-1.74,1.13,28.14-.84-1.56.84,47.49-1.18-1.81,1.18L374,368.27l-2.11,1.38,28.67-.86,28.68.86ZM108,357.62v1.69l-.5-.52Zm5.13,7.89,4.47-.09-1.23.79Zm30-2.91-.54.12.37-.75Zm36.13,0-.54.12L179,362Zm3,3,7.63-.16-2.09,1.36Zm33.13-3-.54.12.37-.75Zm3,3,7.63-.16-2.09,1.36Zm33.13-3-.54.12.37-.75Zm3,3,7.63-.16L260,366.78Zm35.41-.16H290l0,0Zm34.63.2,9.85-.2L332,367Zm49.81,2.44-10.77-2.33,14.83-.31Zm26.43-7.86-.21,0-.2,0,.2-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,365.42l22.62.47-7.88-2.35-1.56-.36-2.55-.58,1.71-6.11-2.74,2.82v-5.17L428.19,356l-3.08-5.64-1.37,3.76-2.4-7.52L420,354.14l-3.77-4.23v7.52l-5.15-3.76-.34,3.76-3.43-6.58-1,6.11-3.08-4.23.34,5.17-1.72-1.11.93-2.18L400.54,356l-2.17-1.39.93,2.18-1.72,1.11.34-5.17L394.83,357l-1-6.11-3.42,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52L376,350.38,372.89,356l-4.11-1.88v5.17L366,356.49l1.71,6.11-2.56.58-1.55.36-1.58.47H358.7l2.06-4.23-4.46.47,2.4-5.64-5.14,3.29.34-5.17L350.82,357l-1-6.11-3.43,6.58-.34-3.76-5.14,3.76v-7.52l-3.77,4.23-1.38-7.52-2.4,7.52L332,350.38,328.88,356l-4.12-1.88v5.17L322,356.49l1.72,6.11-2.56.58-1.56.36-.12,0,2.22-3.79-5.35.47,2.88-5.64-6.18,3.29.41-5.17-3.7,4.23-1.24-6.11-4.12,6.58-.41-3.76-6.18,3.76v-7.52l-4.53,4.23-1.65-7.52-2.88,7.52-1.65-3.76L283.41,356l-1.94-.74.17-2.55-1.49,2-1.68-.64v2.29l-.94-5.58-3.43,6.58-.34-3.76-5.15,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L256.62,356l-4.12-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64-5.14,3.29.34-5.17L242.42,357l-1-6.11L238,357.43l-.34-3.76-5.15,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L220.49,356l-4.12-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64L209,357.9l.34-5.17L206.29,357l-1-6.11-3.42,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L184.35,356l-4.11-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64-5.15,3.29.35-5.17L170.16,357l-1-6.11-3.42,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L148.22,356l-4.11-1.88v5.17l-2.74-2.82,1,3.46-2.82.3,2.4-5.64-5.15,3.29.35-5.17L134,357l-1-6.11-3.43,6.58-.34-3.76-5.14,3.76v-7.52l-3.77,4.23L119,346.62l-2.4,7.52-1.37-3.76L112.09,356l-2.87-1.32,0-.09-.11.06-1.17-.53v1.29l-2.33,1.48-.41-.42.16.59-1.28.82.34-5.17L101.37,357l-1-6.11-3.43,6.58-.35-3.76-5.14,3.76v-7.52l-3.77,4.23-1.37-7.52-2.4,7.52-1.37-3.76L79.44,356l-4.12-1.88v5.17l-2.74-2.82,1.71,6.11-2.55.58-1.56.36-7.88,2.35,22.62-.47-6.51,4.23,34.22-1-1.57,1,37.87-1.13-1.74,1.13,37.87-1.13-1.73,1.13,37.86-1.13-1.73,1.13,37.87-1.13-1.74,1.13,28.14-.84-1.56.84,47.49-1.18-1.81,1.18L374,368.27l-2.11,1.38,28.67-.86,28.68.86ZM108,357.62v1.69l-.5-.52Zm5.13,7.89,4.47-.09-1.23.79Zm30-2.91-.54.12.37-.75Zm36.13,0-.54.12L179,362Zm3,3,7.63-.16-2.09,1.36Zm33.13-3-.54.12.37-.75Zm3,3,7.63-.16-2.09,1.36Zm33.13-3-.54.12.37-.75Zm3,3,7.63-.16L260,366.78Zm35.41-.16H290l0,0Zm34.63.2,9.85-.2L332,367Zm49.81,2.44-10.77-2.33,14.83-.31Zm26.43-7.86-.21,0-.2,0,.2-.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.58,243.54s8.87,3.39,13.42,11.58,12.19,42,12.19,42,13.82,1.09,16.73,1.09,21.1-1.46,21.1-1.46l.91,5.64s-12,5.1-22.92,6.37-23.47.73-25.47-.54-12.18-27.11-12.18-27.11-2.19-11.46-4-19.47S197.81,246.34,201.58,243.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "212.91 259.72 207.96 269.96 212.58 266",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,296.77s-18.19,1.46-21.1,1.46-16.73-1.09-16.73-1.09-1.7-7.51-4-16.31a106.47,106.47,0,0,0-15.16,7c3.17,7.75,8.15,19.54,9.48,20.39,2,1.27,14.56,1.81,25.47.54s22.92-6.37,22.92-6.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,303.32l-4.73-.18L255,307.51l-1.82-11.64,10.37.54a67.11,67.11,0,0,1,7.09-3.46c1.46-.36,7.83.19,7.83.19s.36.72-.55,1.27L277,295s5.46,1.81,6.37,2.54-.37,2.37-.37,2.37a3.25,3.25,0,0,1-1.82,2,11.48,11.48,0,0,1-4,1.09S274.48,303.32,273.21,303.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.74,369.77s4.42-.45,6.39-2.43-2.28-5.17-4.56-3.35S186.68,365.82,187.74,369.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,241.26a51.71,51.71,0,0,0-16.88,11.56c-8.52,8.52-9,20.23-10.8,31.18s-.3,35.13.15,43,7.3,17.49,19.93,29.81,39.52,30.87,48.34,30.87,12.87-9.83,11.71-18.41c-2.83-20.87-31.92-49.88-33.59-53.37s-.76-8.83-.61-9.74,5.63-26.46,7-33.61-2.74-25.85-6.24-28.29S193.07,239.44,184.55,241.26Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,321.87s4.57-4.72,8.22-5.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,307.87s12.47,8.22,41.22,2.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,312s19.77,7.15,37.87.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,276.85a52.72,52.72,0,0,0,21.59-5.17l-.45,2.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,356.43s16.66,16.15,20.77,17.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,345.81s1.5-10,11.5-19.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,356.43s-7.07,7-8,13.34l-13.83-14.44A12.56,12.56,0,0,0,171,353.8c-.61,0-3.2,5.78-4.72,8.07s-3.19.15-3-3.65,4.79-10.76,5.55-14.11,3.34-5.78,5.62-5.17S195.73,356.43,195.73,356.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.61,297.23c4.11-.15,13.53-2.59,17.64-9s4.11-21.9,1.22-30.12c-2.14-6.07-5.6-8-7.26-8.57-1.17,1-2.35,2.06-3.54,3.25-8.52,8.52-9,20.23-10.8,31.18a92.68,92.68,0,0,0-.86,13.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,241.26a45.9,45.9,0,0,0-10.23,5.86,16.44,16.44,0,0,1,5.52,5.55c2.58,4.56,4.56,17.79,4.56,17.79s1.06,0,8.36-1.06a68.18,68.18,0,0,0,14-3.81c-.31-3.49-3.65-19.77-5.18-22a5.29,5.29,0,0,0-.55-.67A26.14,26.14,0,0,0,184.55,241.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.88,252.13s6.6,10.9,12.22,9.9,5.61-7.92,5.61-7.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.81,230s-.45,11.86,0,15.81,6.24,12.47,10.95,11.87,4.57-12.93,4.57-12.93-8.06-11.86-10.35-14S182.57,228.64,181.81,230Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.51,228s-3-2.44-4.56-.31,1.06,7.45,3.34,8.21,3,.31,3,.31a45.4,45.4,0,0,0,4.11,8.67c2.13,3,8.82,8.67,13.38,7s6.7-12,7.46-16.27a40.89,40.89,0,0,0,.76-5.32,62,62,0,0,0-11.56-1.68C191.09,228.3,181.51,228,181.51,228Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.86,229.21s.91,4.72-.46,5-2.89-6.23-2.89-6.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,233.77s.76,7-.46,7.61-3.34-.61-3.34-.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.42,226s7.66,7.83,14.66,8.5,24-3.83,25-5.66-8.83-6.34-8.83-6.34-1.17-12-2.67-15-10.49-5.66-18-3.33-12.5,4.83-12.33,9S179.42,226,179.42,226Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,226.62c7,.57,19.37.75,25.58-4.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,272.74s2.59,12.93,4.41,19.93,2.13,9.73,3.65,10.34,50.65-7.15,50.65-7.15v-5.32l-37.11-3.65s-3.4-24.34-5-27.38a5.22,5.22,0,0,0-5-2.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,276.7A24.12,24.12,0,0,0,162.12,284c.68,3.09,1.41,6.27,2,8.72,1.83,7,2.13,9.73,3.65,10.34s50.65-7.15,50.65-7.15v-5.32l-37.11-3.65S180.9,282.2,180.18,276.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.36,286.89s-7.15-.61-10.8,2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.72,286.92s5.28-3.17,9.51-4.09l-8.72,6.34,1.32,1.72,10.31-4.49s-4.1,4.23-6.34,5.15a25.08,25.08,0,0,0-3.84,2l-4-5.95Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,295s-.3,1.67-2.89,3.8-5.78,1.82-3.34,2.58,5.47-.3,8.51-5.47S237.93,295,237.93,295Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.66,288.86l.61,9.13,8.67-2a20.08,20.08,0,0,0,4,1.37,29.64,29.64,0,0,0,8.82-.91,9.54,9.54,0,0,1,2.58-.61s-1.06,2,.15,2,3.81-.76,4.57-1.83.61-3.34.61-3.34.3-2.29-.61-3.5-4-4-5.48-3.8-14.9,3.34-16,3.65S214.66,288.86,214.66,288.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24,310.31s-7.61,10-8.82,20.23,2.28,23,3.49,25.55.92,4.86,4.11,5.32,19,.61,19.77-2.13,1.37-38.78.76-44.11-8.06-7.9-11.25-7.9A12.1,12.1,0,0,0,165.24,310.31Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,357.15a70.89,70.89,0,0,0,25.55-1.67s-.66,39.42-.2,40.33,8.06,10.5,10.8,12.93,3.19,3.2,1.52,5-4.26,3.95-12.32.61-10.49-9.58-12.78-12.62-1.82-3.81-1.82-8.37S159.15,357.15,159.15,357.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,357.31a41.35,41.35,0,0,1-4.5-12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,357.31s3.5-5.5,2.5-9.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114,359.68l1.06,19.7a4.75,4.75,0,0,0,3.07,4.2,28.62,28.62,0,0,0,20.74,0,4.74,4.74,0,0,0,3.07-4.16l1.24-19.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,352.94v7c0,1.24,7.13,2.25,15.92,2.25s15.92-1,15.92-2.25v-7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.48,
    cy: 352.94,
    rx: 15.92,
    ry: 2.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.31,354c2.64.73,8,1.23,14.17,1.23s11.53-.5,14.17-1.23c-2.64-.72-8-1.22-14.17-1.22S117,353.24,114.31,354Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.42,338.65s-1.23,9-.41,14.9h8.77a107.09,107.09,0,0,0,4.09-13.67l-6.53,1.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,337.57l-.2,0a2,2,0,0,1-1.72-2.25l2.24-16.46a2,2,0,1,1,4,.53l-2.23,16.47A2,2,0,0,1,132.07,337.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,346.93h-.1a1,1,0,0,1-.85-1.12l1.41-10.37a1,1,0,0,1,2,.27l-1.41,10.37A1,1,0,0,1,130.69,346.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,360.93l1.07,19.7a4.73,4.73,0,0,0,3.07,4.2,28.62,28.62,0,0,0,20.74,0,4.73,4.73,0,0,0,3.06-4.16l1.25-19.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,354.19v7c0,1.24,7.13,2.25,15.92,2.25s15.92-1,15.92-2.25v-7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 317.95,
    cy: 354.19,
    rx: 15.92,
    ry: 2.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78,355.21c2.64.73,8,1.23,14.17,1.23s11.53-.5,14.17-1.23c-2.64-.72-8-1.22-14.17-1.22S306.42,354.49,303.78,355.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.73,355.31s-.75-35.5-2.25-39.75-10.5-9.25-10.5-6.5a7.43,7.43,0,0,0,2,4.75s-14.5-2-11.75,1.5,9,2,9,2-14.25,4.25-7,5.25a97.26,97.26,0,0,0,12,1s-4.5,4-.75,4a16,16,0,0,0,6-1l1.75,28.75Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,355.31l-2.94-39.75s10-10.75,10.75-8-4,5.75-2,5.75,13.25-6.25,14.75-1.75-15.75,5.75-13,7.25,10,1.25,4.5,3-14,3.25-11.25,4.5,1.5,2,.5,3.25l-.5,25.75Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.73,355.56s-3-5.25-3-7.75.75-6-.75-9.5-5.75.25-6.75,1-4-5-6.25-3.75,1.75,3.5,1,4.5-12.25-2.25-12.25,1.25,11.25.5,12.25,1.75-6.75,3-2.75,4.25,6.5-2.75,6.75-1.25-6,3.25-1.25,4.5,6.5-.25,8,.5,3.75,4.5,3.75,4.5Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,355.56s3-5.25,3-7.75-.75-6,.75-9.5,5.75.25,6.75,1,4-5,6.25-3.75-1.75,3.5-1,4.5,12.25-2.25,12.25,1.25-11.25.5-12.25,1.75,6.75,3,2.75,4.25-6.5-2.75-6.75-1.25,6,3.25,1.25,4.5-6.5-.25-8,.5-3.75,4.5-3.75,4.5Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23,355.31s-1.5-22.5-2-23.5-3.75.25-7.75,2-2.5,1-4.75.25-5.25.25-9.25,1-3-4.25,1.25-5.75a25.81,25.81,0,0,1,7.75-1.5s-5-2.25-.5-3,9.75,2.75,12.25,4.25a5.31,5.31,0,0,1,2.75,3.5l1.75,22.75Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,355.31s1.5-22.5,2-23.5,3.75.25,7.75,2,2.5,1,4.75.25,5.25.25,9.25,1,3-4.25-1.25-5.75a25.81,25.81,0,0,0-7.75-1.5s5-2.25.5-3-9.75,2.75-12.25,4.25a5.31,5.31,0,0,0-2.75,3.5l-1.75,22.75Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,360.93l1.07,19.7a4.75,4.75,0,0,0,3.07,4.2,28.62,28.62,0,0,0,20.74,0,4.74,4.74,0,0,0,3.07-4.16l1.24-19.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,354.19v7c0,1.24,7.13,2.25,15.92,2.25s15.92-1,15.92-2.25v-7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.08,
    cy: 354.19,
    rx: 15.92,
    ry: 2.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.92,355.21c2.63.73,8,1.23,14.16,1.23s11.54-.5,14.17-1.23c-2.63-.72-8-1.22-14.17-1.22S347.55,354.49,344.92,355.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,338.55a103.74,103.74,0,0,1,6.26,16.87s-.6-20.13-2.05-27.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.08,333s-5.3,11.45-6.26,22.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,342.52s-5.3,8.32-5.91,12.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41,346.86a34.3,34.3,0,0,1,1.56,8.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.68,325.9s-2.2-2.49-3.83-1.68-1.9,2.17.54,2.71-3.09.23-2,2.94,3.74-2,4.82-.36,1,3.09,2.53,2.41c2.77-1.21-.45-3.13.36-4.22s2.44-.22,2.44-1.85S358.4,322.91,355.68,325.9Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,331.44s-2.21-2.49-3.84-1.68-1.9,2.17.54,2.72-3.09.22-2,2.93,3.74-2,4.82-.36,1,3.1,2.53,2.41c2.78-1.2-.45-3.13.37-4.21s2.43-.23,2.43-1.86S368.64,328.45,365.93,331.44Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,345.54s-2.21-2.49-3.84-1.68-1.89,2.17.55,2.71-3.1.23-2,2.94,3.73-2,4.82-.36.95,3.09,2.53,2.41c2.77-1.21-.46-3.13.36-4.22s2.43-.22,2.43-1.85S359.48,342.55,356.77,345.54Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.47,336.86s-2.21-2.49-3.84-1.67-1.9,2.17.54,2.71-3.09.22-2,2.94,3.73-2,4.82-.37.95,3.1,2.53,2.41c2.77-1.2-.46-3.13.36-4.21s2.43-.23,2.43-1.86S354.18,333.88,351.47,336.86Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,341.32s-2.21-2.49-3.83-1.68-1.9,2.17.54,2.72-3.1.22-2,2.93,3.73-2,4.82-.36,1,3.1,2.53,2.41c2.77-1.2-.45-3.13.36-4.21s2.43-.23,2.43-1.86S369.84,338.33,367.13,341.32Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,390.8s-5.51-17.1,11.4-50.08.85-86.24.85-86.24",
    style: {
      fill: "none",
      stroke: "#008C8E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,389.77s-5.92-12.68.84-31.29,5-29.16,5-29.16",
    style: {
      fill: "none",
      stroke: "#008C8E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,332.29S284,316.2,289.08,296.75c1.17-4.49,2.07-8.44,2.77-11.87",
    style: {
      fill: "none",
      stroke: "#008C8E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.92,391.11s7.86-15.72,9.56-38.55a121.75,121.75,0,0,0-4.23-41.43",
    style: {
      fill: "none",
      stroke: "#008C8E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.89,340.66c-.07.5-.76.87-.89,1.35s.28,1.16.09,1.62-.95.65-1.2,1.08,0,1.19-.34,1.59-1.09.38-1.45.73-.33,1.14-.73,1.45-1.15.08-1.58.33-.62,1-1.09,1.21-1.13-.22-1.61-.09-.86.82-1.36.89-1-.51-1.54-.51-1.05.57-1.55.51-.87-.76-1.35-.89-1.16.28-1.62.09-.65-.95-1.08-1.2-1.19,0-1.59-.34-.38-1.09-.73-1.45-1.14-.33-1.45-.73-.08-1.15-.33-1.58-1-.62-1.21-1.09.22-1.13.09-1.61-.82-.86-.89-1.36.51-1,.51-1.54-.57-1.05-.51-1.54.76-.88.89-1.36-.28-1.16-.09-1.62,1-.65,1.21-1.08,0-1.19.33-1.59,1.09-.38,1.45-.73.33-1.14.73-1.45,1.15-.08,1.59-.33.61-1,1.08-1.21,1.13.22,1.62.09.85-.82,1.35-.89,1,.51,1.55.51,1-.57,1.54-.51.87.76,1.35.89,1.16-.28,1.62-.09.65,1,1.08,1.21,1.19,0,1.59.33.38,1.09.73,1.45,1.14.33,1.45.73.08,1.15.33,1.59,1,.61,1.21,1.08-.22,1.13-.09,1.62.82.85.89,1.35-.51,1-.51,1.55S262,340.16,261.89,340.66Zm16-33.35c0-.64.71-1.32.63-1.94s-1-1.11-1.11-1.71.35-1.46.11-2-1.21-.82-1.52-1.37,0-1.49-.43-2-1.37-.48-1.82-.93-.42-1.43-.92-1.82-1.45-.1-2-.42-.78-1.28-1.36-1.52-1.43.27-2,.11-1.08-1-1.72-1.12-1.3.64-1.94.64-1.32-.72-1.94-.64-1.11,1-1.71,1.12-1.46-.35-2-.11-.82,1.2-1.37,1.52-1.49,0-2,.42-.47,1.38-.92,1.82-1.43.43-1.82.93-.11,1.45-.42,2-1.28.77-1.52,1.36.27,1.42.1,2-1,1.08-1.11,1.71.64,1.3.64,1.94-.72,1.33-.64,1.95,1,1.1,1.12,1.71-.36,1.46-.11,2,1.2.82,1.52,1.36,0,1.5.42,2,1.38.48,1.82.92.42,1.44.93,1.83,1.45.1,2,.42.78,1.28,1.37,1.52,1.42-.27,2-.11,1.08,1,1.71,1.11,1.3-.63,1.94-.63,1.32.71,1.94.63,1.11-.95,1.72-1.11,1.46.35,2,.11.82-1.21,1.36-1.52,1.5,0,2-.43.48-1.37.92-1.82,1.44-.42,1.82-.92.11-1.45.43-2,1.28-.78,1.52-1.36-.28-1.43-.11-2,1-1.08,1.11-1.71S277.85,308,277.85,307.31ZM279.56,364c0-.64.71-1.32.63-1.94s-.95-1.11-1.11-1.72.35-1.45.11-2-1.21-.81-1.52-1.36,0-1.5-.43-2-1.37-.47-1.82-.92-.42-1.44-.92-1.82-1.45-.11-2-.43-.78-1.27-1.36-1.52-1.43.28-2,.11-1.08-1-1.72-1.11-1.3.64-1.94.64-1.32-.72-1.94-.64-1.11.95-1.71,1.11-1.46-.35-2-.11-.82,1.21-1.37,1.52-1.49,0-2,.43-.48,1.37-.93,1.82-1.43.42-1.82.92-.11,1.45-.42,2-1.28.78-1.52,1.37.27,1.42.11,2-1,1.07-1.12,1.71.64,1.3.64,1.94-.72,1.32-.64,1.94.95,1.11,1.12,1.72-.35,1.45-.11,2,1.2.81,1.52,1.36,0,1.5.42,2,1.38.47,1.82.92.43,1.44.93,1.82,1.45.11,2,.43.77,1.27,1.36,1.52,1.42-.28,2-.11,1.08,1,1.71,1.11,1.3-.64,1.94-.64,1.33.72,1.95.64,1.1-1,1.71-1.11,1.46.35,2,.11.82-1.21,1.36-1.52,1.5,0,2-.43.48-1.37.92-1.82,1.44-.42,1.83-.92.1-1.45.42-2,1.28-.78,1.52-1.37-.27-1.42-.11-2,1-1.07,1.11-1.71S279.56,364.68,279.56,364Zm-29.17,8.06c0-.43.73-.89.67-1.3s-.88-.68-1-1.08.48-1.05.32-1.44-1-.42-1.23-.78.18-1.14-.07-1.47-1.1-.14-1.4-.44-.11-1.14-.44-1.39-1.1.14-1.46-.07-.4-1.07-.79-1.23-1,.42-1.43.31-.66-.93-1.08-1-.88.68-1.3.68-.89-.73-1.3-.68-.68.89-1.08,1-1.05-.47-1.43-.31-.43,1-.79,1.23-1.13-.18-1.46.07-.15,1.1-.44,1.4-1.15.11-1.4.44.14,1.1-.07,1.46-1.07.4-1.23.79.42,1,.32,1.43-.94.66-1,1.08.67.87.67,1.3-.73.89-.67,1.3.88.68,1,1.08-.48,1-.32,1.43,1,.43,1.24.79-.19,1.13.06,1.46,1.1.15,1.4.44.11,1.14.44,1.4,1.1-.15,1.46.06.4,1.08.79,1.24,1-.43,1.43-.32.66.94,1.08,1,.88-.68,1.3-.68.89.73,1.3.68.68-.88,1.08-1,1.05.48,1.43.32.43-1,.79-1.24,1.13.19,1.46-.06.15-1.11.44-1.4,1.15-.11,1.4-.44-.14-1.1.07-1.46,1.07-.4,1.23-.79-.42-1-.31-1.43.93-.66,1-1.08S250.39,372.52,250.39,372.1Zm30.84-116c0-.64.72-1.32.64-1.94s-.95-1.11-1.11-1.72.35-1.45.11-2-1.21-.82-1.52-1.37,0-1.5-.43-2-1.37-.47-1.82-.92-.42-1.44-.92-1.82-1.45-.11-2-.43-.78-1.27-1.37-1.52-1.42.28-2,.11-1.07-1-1.71-1.11-1.3.64-1.94.64-1.32-.72-1.94-.64-1.11,1-1.72,1.11-1.45-.35-2-.11-.81,1.21-1.36,1.52-1.5,0-2,.43-.47,1.37-.92,1.82-1.44.42-1.82.92-.11,1.45-.43,2-1.27.78-1.52,1.37.28,1.42.11,2-1,1.07-1.11,1.71.64,1.3.64,1.94-.72,1.32-.64,1.94.95,1.11,1.11,1.72-.35,1.45-.11,2,1.21.81,1.52,1.36,0,1.5.43,2,1.37.47,1.82.92.42,1.44.92,1.82,1.45.11,2,.43.78,1.27,1.37,1.52,1.42-.28,2-.11,1.07,1,1.71,1.11,1.3-.64,1.94-.64,1.32.72,1.94.64,1.11-.95,1.72-1.11,1.45.35,2,.11.81-1.21,1.36-1.52,1.5,0,2-.43.47-1.37.92-1.82,1.44-.42,1.82-.92.11-1.45.43-2,1.27-.78,1.52-1.37-.28-1.42-.11-2,1-1.07,1.11-1.71S281.23,256.71,281.23,256.07Zm25.84,25.83c0-.64.71-1.32.63-1.94s-.95-1.11-1.11-1.71.35-1.46.11-2-1.21-.82-1.52-1.37,0-1.49-.43-2-1.37-.48-1.82-.93-.42-1.43-.92-1.82-1.45-.1-2-.42-.78-1.28-1.36-1.52-1.43.27-2,.11-1.08-1-1.71-1.12-1.31.64-1.95.64-1.32-.72-1.94-.64-1.11,1-1.71,1.12-1.46-.35-2-.11-.82,1.2-1.37,1.52-1.49,0-2,.42-.48,1.38-.93,1.82-1.43.43-1.82.93-.11,1.45-.42,2-1.28.77-1.52,1.36.27,1.42.11,2-1,1.08-1.12,1.71.64,1.3.64,1.94-.72,1.33-.64,2,.95,1.1,1.12,1.71-.35,1.46-.11,2,1.2.82,1.52,1.36,0,1.5.42,2,1.38.48,1.82.92.43,1.44.93,1.83,1.45.1,2,.42.77,1.28,1.36,1.52,1.42-.27,2-.11,1.08,1,1.71,1.11,1.3-.63,1.94-.63,1.33.71,1.95.63,1.1-.95,1.71-1.11,1.46.35,2,.11.82-1.21,1.36-1.52,1.5,0,2-.43.48-1.37.92-1.82,1.44-.42,1.83-.92.1-1.45.42-2,1.28-.78,1.52-1.36-.27-1.43-.11-2,1-1.08,1.11-1.71S307.07,282.55,307.07,281.9Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.89,340.66c-.07.5-.76.87-.89,1.35s.28,1.16.09,1.62-.95.65-1.2,1.08,0,1.19-.34,1.59-1.09.38-1.45.73-.33,1.14-.73,1.45-1.15.08-1.58.33-.62,1-1.09,1.21-1.13-.22-1.61-.09-.86.82-1.36.89-1-.51-1.54-.51-1.05.57-1.55.51-.87-.76-1.35-.89-1.16.28-1.62.09-.65-.95-1.08-1.2-1.19,0-1.59-.34-.38-1.09-.73-1.45-1.14-.33-1.45-.73-.08-1.15-.33-1.58-1-.62-1.21-1.09.22-1.13.09-1.61-.82-.86-.89-1.36.51-1,.51-1.54-.57-1.05-.51-1.54.76-.88.89-1.36-.28-1.16-.09-1.62,1-.65,1.21-1.08,0-1.19.33-1.59,1.09-.38,1.45-.73.33-1.14.73-1.45,1.15-.08,1.59-.33.61-1,1.08-1.21,1.13.22,1.62.09.85-.82,1.35-.89,1,.51,1.55.51,1-.57,1.54-.51.87.76,1.35.89,1.16-.28,1.62-.09.65,1,1.08,1.21,1.19,0,1.59.33.38,1.09.73,1.45,1.14.33,1.45.73.08,1.15.33,1.59,1,.61,1.21,1.08-.22,1.13-.09,1.62.82.85.89,1.35-.51,1-.51,1.55S262,340.16,261.89,340.66Zm16-33.35c0-.64.71-1.32.63-1.94s-1-1.11-1.11-1.71.35-1.46.11-2-1.21-.82-1.52-1.37,0-1.49-.43-2-1.37-.48-1.82-.93-.42-1.43-.92-1.82-1.45-.1-2-.42-.78-1.28-1.36-1.52-1.43.27-2,.11-1.08-1-1.72-1.12-1.3.64-1.94.64-1.32-.72-1.94-.64-1.11,1-1.71,1.12-1.46-.35-2-.11-.82,1.2-1.37,1.52-1.49,0-2,.42-.47,1.38-.92,1.82-1.43.43-1.82.93-.11,1.45-.42,2-1.28.77-1.52,1.36.27,1.42.1,2-1,1.08-1.11,1.71.64,1.3.64,1.94-.72,1.33-.64,1.95,1,1.1,1.12,1.71-.36,1.46-.11,2,1.2.82,1.52,1.36,0,1.5.42,2,1.38.48,1.82.92.42,1.44.93,1.83,1.45.1,2,.42.78,1.28,1.37,1.52,1.42-.27,2-.11,1.08,1,1.71,1.11,1.3-.63,1.94-.63,1.32.71,1.94.63,1.11-.95,1.72-1.11,1.46.35,2,.11.82-1.21,1.36-1.52,1.5,0,2-.43.48-1.37.92-1.82,1.44-.42,1.82-.92.11-1.45.43-2,1.28-.78,1.52-1.36-.28-1.43-.11-2,1-1.08,1.11-1.71S277.85,308,277.85,307.31ZM279.56,364c0-.64.71-1.32.63-1.94s-.95-1.11-1.11-1.72.35-1.45.11-2-1.21-.81-1.52-1.36,0-1.5-.43-2-1.37-.47-1.82-.92-.42-1.44-.92-1.82-1.45-.11-2-.43-.78-1.27-1.36-1.52-1.43.28-2,.11-1.08-1-1.72-1.11-1.3.64-1.94.64-1.32-.72-1.94-.64-1.11.95-1.71,1.11-1.46-.35-2-.11-.82,1.21-1.37,1.52-1.49,0-2,.43-.48,1.37-.93,1.82-1.43.42-1.82.92-.11,1.45-.42,2-1.28.78-1.52,1.37.27,1.42.11,2-1,1.07-1.12,1.71.64,1.3.64,1.94-.72,1.32-.64,1.94.95,1.11,1.12,1.72-.35,1.45-.11,2,1.2.81,1.52,1.36,0,1.5.42,2,1.38.47,1.82.92.43,1.44.93,1.82,1.45.11,2,.43.77,1.27,1.36,1.52,1.42-.28,2-.11,1.08,1,1.71,1.11,1.3-.64,1.94-.64,1.33.72,1.95.64,1.1-1,1.71-1.11,1.46.35,2,.11.82-1.21,1.36-1.52,1.5,0,2-.43.48-1.37.92-1.82,1.44-.42,1.83-.92.1-1.45.42-2,1.28-.78,1.52-1.37-.27-1.42-.11-2,1-1.07,1.11-1.71S279.56,364.68,279.56,364Zm-29.17,8.06c0-.43.73-.89.67-1.3s-.88-.68-1-1.08.48-1.05.32-1.44-1-.42-1.23-.78.18-1.14-.07-1.47-1.1-.14-1.4-.44-.11-1.14-.44-1.39-1.1.14-1.46-.07-.4-1.07-.79-1.23-1,.42-1.43.31-.66-.93-1.08-1-.88.68-1.3.68-.89-.73-1.3-.68-.68.89-1.08,1-1.05-.47-1.43-.31-.43,1-.79,1.23-1.13-.18-1.46.07-.15,1.1-.44,1.4-1.15.11-1.4.44.14,1.1-.07,1.46-1.07.4-1.23.79.42,1,.32,1.43-.94.66-1,1.08.67.87.67,1.3-.73.89-.67,1.3.88.68,1,1.08-.48,1-.32,1.43,1,.43,1.24.79-.19,1.13.06,1.46,1.1.15,1.4.44.11,1.14.44,1.4,1.1-.15,1.46.06.4,1.08.79,1.24,1-.43,1.43-.32.66.94,1.08,1,.88-.68,1.3-.68.89.73,1.3.68.68-.88,1.08-1,1.05.48,1.43.32.43-1,.79-1.24,1.13.19,1.46-.06.15-1.11.44-1.4,1.15-.11,1.4-.44-.14-1.1.07-1.46,1.07-.4,1.23-.79-.42-1-.31-1.43.93-.66,1-1.08S250.39,372.52,250.39,372.1Zm30.84-116c0-.64.72-1.32.64-1.94s-.95-1.11-1.11-1.72.35-1.45.11-2-1.21-.82-1.52-1.37,0-1.5-.43-2-1.37-.47-1.82-.92-.42-1.44-.92-1.82-1.45-.11-2-.43-.78-1.27-1.37-1.52-1.42.28-2,.11-1.07-1-1.71-1.11-1.3.64-1.94.64-1.32-.72-1.94-.64-1.11,1-1.72,1.11-1.45-.35-2-.11-.81,1.21-1.36,1.52-1.5,0-2,.43-.47,1.37-.92,1.82-1.44.42-1.82.92-.11,1.45-.43,2-1.27.78-1.52,1.37.28,1.42.11,2-1,1.07-1.11,1.71.64,1.3.64,1.94-.72,1.32-.64,1.94.95,1.11,1.11,1.72-.35,1.45-.11,2,1.21.81,1.52,1.36,0,1.5.43,2,1.37.47,1.82.92.42,1.44.92,1.82,1.45.11,2,.43.78,1.27,1.37,1.52,1.42-.28,2-.11,1.07,1,1.71,1.11,1.3-.64,1.94-.64,1.32.72,1.94.64,1.11-.95,1.72-1.11,1.45.35,2,.11.81-1.21,1.36-1.52,1.5,0,2-.43.47-1.37.92-1.82,1.44-.42,1.82-.92.11-1.45.43-2,1.27-.78,1.52-1.37-.28-1.42-.11-2,1-1.07,1.11-1.71S281.23,256.71,281.23,256.07Zm25.84,25.83c0-.64.71-1.32.63-1.94s-.95-1.11-1.11-1.71.35-1.46.11-2-1.21-.82-1.52-1.37,0-1.49-.43-2-1.37-.48-1.82-.93-.42-1.43-.92-1.82-1.45-.1-2-.42-.78-1.28-1.36-1.52-1.43.27-2,.11-1.08-1-1.71-1.12-1.31.64-1.95.64-1.32-.72-1.94-.64-1.11,1-1.71,1.12-1.46-.35-2-.11-.82,1.2-1.37,1.52-1.49,0-2,.42-.48,1.38-.93,1.82-1.43.43-1.82.93-.11,1.45-.42,2-1.28.77-1.52,1.36.27,1.42.11,2-1,1.08-1.12,1.71.64,1.3.64,1.94-.72,1.33-.64,2,.95,1.1,1.12,1.71-.35,1.46-.11,2,1.2.82,1.52,1.36,0,1.5.42,2,1.38.48,1.82.92.43,1.44.93,1.83,1.45.1,2,.42.77,1.28,1.36,1.52,1.42-.27,2-.11,1.08,1,1.71,1.11,1.3-.63,1.94-.63,1.33.71,1.95.63,1.1-.95,1.71-1.11,1.46.35,2,.11.82-1.21,1.36-1.52,1.5,0,2-.43.48-1.37.92-1.82,1.44-.42,1.83-.92.1-1.45.42-2,1.28-.78,1.52-1.36-.27-1.43-.11-2,1-1.08,1.11-1.71S307.07,282.55,307.07,281.9Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.29 393.26 237.69 393.03 239.99 392.65 238.45 388.65 240.91 390.49 240.91 387.11 244.6 388.34 247.38 384.64 248.61 387.11 250.76 382.18 251.99 387.11 255.38 384.34 255.38 389.26 260 386.8 260.3 389.26 263.38 384.95 264.31 388.95 267.08 386.18 266.77 389.57 271.39 387.42 269.23 391.11 273.23 390.8 271.39 393.57 280.93 393.57 274.46 394.5 286.16 396.34 243.68 397.26 249.53 394.5 229.21 394.8 236.29 393.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.29 393.26 237.69 393.03 239.99 392.65 238.45 388.65 240.91 390.49 240.91 387.11 244.6 388.34 247.38 384.64 248.61 387.11 250.76 382.18 251.99 387.11 255.38 384.34 255.38 389.26 260 386.8 260.3 389.26 263.38 384.95 264.31 388.95 267.08 386.18 266.77 389.57 271.39 387.42 269.23 391.11 273.23 390.8 271.39 393.57 280.93 393.57 274.46 394.5 286.16 396.34 243.68 397.26 249.53 394.5 229.21 394.8 236.29 393.26",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardeningImg);
export default __webpack_public_path__ + "static/media/gardening_img.cfec902d2b9d87b18e312895182bc602.svg";
export { ForwardRef as ReactComponent };